// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__hlTI0","right":"styles_right__1C4jY"};